import {photoUrl} from '../../shared/api/usePeople';
import type {Shoutout} from '../../shared/types';
import type {ImportedOption} from './editorState';

// What the API accepts per vote and per option.
export const MAX_OPTIONS = 30;
export const MAX_PEOPLE = 20;

/** How many options too many an import would leave the vote with; zero when it fits. */
export const overLimit = (existing: number, adding: number): number =>
    Math.max(0, existing + adding - MAX_OPTIONS);

/** The first of last month, as `YYYY-MM-DD`: where a monthly shoutout import usually starts. */
export const defaultSince = (now: Date): string =>
    new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - 1, 1)).toISOString().slice(0, 10);

export const toImportedOption = (shoutout: Shoutout, id: string): ImportedOption => ({
    id,
    description: shoutout.text,
    people: shoutout.people.slice(0, MAX_PEOPLE).map((p) => ({
        humaansId: p.humaans_id,
        name: p.name,
        photoUrl: p.has_photo ? photoUrl(p.id) : null,
    })),
});
